export default {"MODE":"production","NODE_ENV":"production"};